export default {
  translation: {
    nav: {
      home: 'Koti',
      trips: 'Matkat',
      aboutUs: 'Tietoa meistä',
      alerts: 'Ilmoitukset',
      wishlist: 'Toivelista',
      language: 'Kieli',
      profile: 'Profiili',
      settings: 'Asetukset',
      signIn: 'Kirjaudu',
      signUp: 'Rekisteröidy'
    },
    hero: {
      title: 'Tutki Ugandaa',
      subtitle: 'ja kauemmas',
      description: 'Löydä Afrikan helmi asiantuntevien paikallisoppaiden kanssa. Unohtumattomia kokemuksia odottaa Ugandan henkeäsalpaavissa maisemissa ja eloisassa kulttuurissa.',
      searchPlaceholder: 'Minne haluat matkustaa?',
      categories: {
        all: 'Kaikki',
        wildlife: 'Villieläimet',
        safari: 'Safari',
        cultural: 'Kulttuuri',
        adventure: 'Seikkailu',
        birding: 'Lintujen tarkkailu'
      }
    },
    common: {
      from: 'alkaen',
      reviews: 'arvostelua',
      viewMore: 'Näytä lisää',
      book: 'Varaa',
      seeAll: 'Näytä kaikki',
      loading: 'Ladataan...'
    }
  }
};